
export interface CustomerLine {
  CustomerId: string,
  CustomerPackageId: null,
  LineId: string,
  MusicOnHoldId: null,
  Extension: null,
  Title: null,
  VoiceMailCreated: null,
  ActivationDate: string,
  PersianActivationDate: string,
  ExpirationDate: string,
  PersianExpirationDate: string,
  LineType: number,
  Enabled: boolean,
  RecordEnabled: boolean,
  Color: null,
  Line: LineCustomer,
  Customer: null,
  MusicOnHold: null,
  SecretaryIncomingCallSmsNotificationReceivers: [],
  TransferedCallBySecretarySmsNotificationReceivers: [],
  SecretaryReportSmsNotificationReceivers: [],
  SecretaryIncomingCallTelegramNotificationReceivers: [],
  TransferedCallBySecretaryTelegramNotificationReceivers: [],
  SecretaryReportTelegramNotificationReceivers: [],
  IvrIncomingCallSmsNotificationReceivers: [],
  TransferedCallByIvrSmsNotificationReceivers: [],
  IvrIncomingCallTelegramNotificationReceivers: [],
  TransferedCallByIvrTelegramNotificationReceivers: [],
  Id: string,
  Errors: [],
  Confirms: [],
  Delete: boolean,
  PageIndex: number,
  PageSize: number
}

export interface LineCustomer {
  Number: string,
  Status: number,
  ReservationDate: null,
  LineType: number,
  Id: string,
  Errors: null,
  Confirms: null,
  Delete: false,
  PageIndex: number,
  PageSize: number

}

export class GetCustomerLinesResponse {
  lineList: CustomerLine[] = [];
  constructor(list: any[]) {
    let tempList: CustomerLine[] = [];
    list.forEach((item: any) => {
      let tempLineCustomer: LineCustomer = {
        Number: item.line.number,
        Status: item.line.status,
        ReservationDate: null,
        LineType: item.line.lineType,
        Id: item.line.id,
        Errors: null,
        Confirms: null,
        Delete: false,
        PageIndex: 0,
        PageSize: 0
      }
      let temp: CustomerLine = {
        CustomerId: item.customerId,
        CustomerPackageId: null,
        LineId: "",
        MusicOnHoldId: null,
        Extension: null,
        Title: item.title,
        VoiceMailCreated: null,
        ActivationDate: item.activationDate,
        PersianActivationDate: item.persianActivationDate,
        ExpirationDate: item.expirationDate,
        PersianExpirationDate: item.persianExpirationDate,
        LineType: item.lineType,
        Enabled: item.enabled,
        RecordEnabled: item.recordEnabled,
        Color: item.color,
        Line: tempLineCustomer,
        Customer: null,
        MusicOnHold: null,
        SecretaryIncomingCallSmsNotificationReceivers: [],
        TransferedCallBySecretarySmsNotificationReceivers: [],
        SecretaryReportSmsNotificationReceivers: [],
        SecretaryIncomingCallTelegramNotificationReceivers: [],
        TransferedCallBySecretaryTelegramNotificationReceivers: [],
        SecretaryReportTelegramNotificationReceivers: [],
        IvrIncomingCallSmsNotificationReceivers: [],
        TransferedCallByIvrSmsNotificationReceivers: [],
        IvrIncomingCallTelegramNotificationReceivers: [],
        TransferedCallByIvrTelegramNotificationReceivers: [],
        Id: item.id,
        Errors: [],
        Confirms: [],
        Delete: false,
        PageIndex: 0,
        PageSize: 0
      }
      tempList.push(temp)

    })
    this.lineList = tempList;
  }
}


export interface secretaryCallReportItem {
  CustomerId: string,
  Date: string,
  PersianDate: string,
  Report: string,
  IsStarred: boolean,
  FromNumber: string,
  ToNumber: string,
  CustomerFullName: string,
  Operator: null,
  Id: string,
  IsIncomeCall: boolean,
  TransferToNumber: string,
  NumberClicked: boolean
}

interface ToNumber {
  Number: string
  Status: number,
  ReservationDate: null,
  LineType: number,
  Id: string,
  Errors: [],
  Confirms: [],
  Delete: boolean,
  PageIndex: number,
  PageSize: number
}

export class SecretaryCallReport {
  data: secretaryCallReportItem[] = [];
  pageNumber: number = 0;
  pageSize: number = 0;
  totalCount: number = 0;
  constructor(result: any) {
    let tempList: secretaryCallReportItem[] = []
    result.data.forEach((item: any) => {

      let tempModel: secretaryCallReportItem = {
        CustomerId: item.customerId,
        Date: item.date,
        PersianDate: item.persianDate,
        Report: item.report,
        IsStarred: item.isStarred,
        FromNumber: item.fromNumber,
        ToNumber: item.toNumber,
        CustomerFullName: item.customerFullName,
        Operator: item.operatorFullName,
        Id: item.id,
        IsIncomeCall: item.isIncomeCall,
        TransferToNumber: item.transferToNumber,
        NumberClicked: false
      }
      tempList.push(tempModel)
      this.pageNumber = result.pageNumber;
      this.pageSize = result.pageSize;
      this.totalCount = result.totalCount;
    })
    this.data = tempList;
  }
}

export interface CallReportDetailResponse {
  CallReportNotes: CallReportNoteItems[],
  CallerInformation: CallerInformation[],
  CallReportId: string,
  FromNumber: string,
  ToNumber: string,
  TransferToNumber: string,
  Date: string,
  IsStarred: boolean,
  IsIncomeCall: boolean,
  Report: string,
  Id: string,
  NumberClicked: boolean,
  PersianDate: string

}


export interface SaveResponse {
  CallReportId: string,
  Date: string,
  Note: string,
  CallReport: null,
  Id: string,
  Errors: null,
  Confirms: null,
  Delete: boolean,
  PageIndex: number
  PageSize: number
}

export class CallReportDetails {
  model: CallReportDetailResponse = {
    CallReportNotes: [],
    CallerInformation: [],
    CallReportId: "",
    FromNumber: "",
    ToNumber: "",
    TransferToNumber: "",
    Date: "",
    IsStarred: false,
    IsIncomeCall: false,
    Report: "",
    Id: "",
    NumberClicked: false,
    PersianDate: ""
  };


  constructor(apiResponse: any) {

    if (apiResponse) {

      let callerInformation: CallerInformation[] = []
      if (apiResponse.callerInformation && Array.isArray(apiResponse.callerInformation) && apiResponse.callerInformation.length > 0) {
        apiResponse.callerInformation.forEach((callerInformationItem: any) => {
          let callerInformationItemTemp: CallerInformationItemsItem[] = [];

          if (callerInformationItem.items && typeof callerInformationItem.items === "object" && Array.isArray(callerInformationItem.items) && callerInformationItem.items.length > 0) {
            callerInformationItem.items.forEach((_callerInformationItem: any) => {
              const tempItem: CallerInformationItemsItem = {
                Name: _callerInformationItem.name,
                Value: _callerInformationItem.value
              }
              callerInformationItemTemp.push(tempItem)
            })
          }
          const callReportNoteItems: CallerInformation = {
            Items: callerInformationItemTemp,
            SectionName: callerInformationItem.sectionName
          }
          callerInformation.push(callReportNoteItems)
        })
      }
      let CallReportNoteItemsTemp: CallReportNoteItems[] = []
      if (apiResponse.callReportNotes && Array.isArray(apiResponse.callReportNotes) && apiResponse.callReportNotes.length > 0) {
        apiResponse.callReportNotes.forEach((_callReportNotesItem: any) => {
          const tempCallReportNoteItems: CallReportNoteItems = {
            Id: _callReportNotesItem.id,
            CallReportId: _callReportNotesItem.callReportId,
            Date: _callReportNotesItem.date,
            Note: _callReportNotesItem.note
          }
          CallReportNoteItemsTemp.push(tempCallReportNoteItems)
        })
      }

      let tempModel: CallReportDetailResponse = {
        CallReportNotes: CallReportNoteItemsTemp,
        CallerInformation: callerInformation,
        CallReportId: apiResponse.callReportId,
        FromNumber: apiResponse.fromNumber,
        ToNumber: apiResponse.toNumber,
        TransferToNumber: apiResponse.transferToNumber,
        Date: apiResponse.date,
        IsStarred: apiResponse.isStarred,
        IsIncomeCall: apiResponse.isIncomeCall,
        Report: apiResponse.report,
        Id: apiResponse.id,
        NumberClicked: false,
        PersianDate: apiResponse.persianDate
      }

      this.model = tempModel;
    }
  }
}


export interface CallerInformationItemsItem {
  Name: string
  Value: string
}

export interface CallerInformation {
  Items: CallerInformationItemsItem[],
  SectionName: string
}

export interface CallReportNoteItems {
  Id: string,
  CallReportId: string,
  Date: string,
  Note: string
}
